import type { PropsWithChildren, FC, ReactNode } from 'react';

import { labelClass } from './InputLabel.css';
import { useI18nTranslation } from '../../providers/i18n';
import { Text } from '../Text/Text';

interface Props {
  htmlFor: string;
  children: ReactNode;
  isOptional?: boolean;
}

/** Internal use only (InputText, InputTelephone, etc.) */
export const Label: FC<PropsWithChildren<Props>> = ({ htmlFor, children, isOptional }) => {
  const i18nOptionalText = useI18nTranslation('optional');

  return (
    <label className={labelClass} htmlFor={htmlFor}>
      <Text size="BodyS" weight="bold">
        {children}
        {isOptional ? <span>{` (${i18nOptionalText})`}</span> : null}
      </Text>
    </label>
  );
};
